import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'whatwg-fetch';
import { Block, Subpages } from '../partials';

const propTypes = {
    blocks: PropTypes.array,
    fixedBlocks: PropTypes.array,
};

const defaultProps = {
    blocks: [],
    fixedBlocks: [
        {
            id: 2,
            type: 'logo',
        },
    ],
};

class HomeLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mediaBlocks: null,
            latestNews: null,
        };
    }

    componentDidMount() {
        this.fetchHome();
    }

    fetchHome() {
        fetch('/api/pages/home')
            .then(response => response.json())
            .then((data) => {
                this.setState(() => ({
                    mediaBlocks: data.medias.map(block => ({
                        ...block,
                        ratio: 1,
                        rounded: true,
                        lightbox: true,
                        background: true,
                        title: null,
                        description: null,
                        subtitle: null,
                        quote: null,
                    })),
                    latestNews: data.news.map(post => ({
                        ...post,
                        blocks: (post.blocks || []).map(block => ({
                            ...block,
                            horizontal: false,
                        })),
                    })),
                }));
            });
    }

    render() {
        const { fixedBlocks, blocks } = this.props;
        const { mediaBlocks, latestNews } = this.state;
        const mediaTypes = ['media', 'image', 'video'];
        const realBlocks = blocks || [];
        const featuredBlocks = realBlocks.filter(block => mediaTypes.indexOf(block.type) !== -1);
        const leftBlocks = realBlocks.filter(block => mediaTypes.indexOf(block.type) === -1);
        return (
            <div className="layout layout-with-cols layout-home">
                <div className="cols">
                    <div className="col col-small">
                        <Block blocks={fixedBlocks} />
                        <Block blocks={leftBlocks} />
                    </div>
                    <div className="col">
                        <div className="col-inner">
                            <Block blocks={featuredBlocks} />
                            { latestNews !== null ? (
                                <div className="news-container">
                                    <h4>Latest news</h4>
                                    <Subpages pages={latestNews} />
                                </div>
                            ) : null }
                        </div>
                    </div>
                </div>

                <div className="clearfix" />
                <div className="caroussel caroussel-horizontal">
                    { mediaBlocks !== null ? (
                        <Block blocks={mediaBlocks} />
                    ) : null }
                </div>
            </div>
        );
    }
}

HomeLayout.propTypes = propTypes;
HomeLayout.defaultProps = defaultProps;

export default HomeLayout;



// WEBPACK FOOTER //
// ./components/layouts/HomeLayout.jsx